import React from 'react';

import Styles from './SauceLogo.styles';

const SauceLogo = () => (
  <h1 className={Styles.default}>
    <a href="https://saucelabs.com/">Sauce Labs</a>
  </h1>
);

export default SauceLogo;
